import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type ShopifyProps = Omit<BusinessIconImageProps, 'color' | 'strokeWidth'>;

const Shopify = forwardRef<SVGSVGElement, ShopifyProps>(
  ({ size = 24, width, height, alt = '', style, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={style}
      {...props}
    >
      <g transform="translate(-2.1 -2.1) scale(1.175)">
        <g mask="url(#mask0_shopify)">
          <path d="M18.7684 5.9C18.7539 5.79916 18.666 5.74166 18.5922 5.74166C18.5184 5.74166 16.9477 5.62709 16.9477 5.62709C16.9477 5.62709 15.8614 4.56625 15.7295 4.45166C15.6117 4.33709 15.377 4.36541 15.2887 4.39416C15.2742 4.39416 15.054 4.46584 14.6722 4.58084C14.3052 3.53416 13.6592 2.58789 12.5285 2.58789H12.4261C12.1176 2.18625 11.7067 2 11.3687 2C8.72622 2 7.46362 5.22584 7.06724 6.86041C6.0389 7.17584 5.305 7.39084 5.21709 7.41916C4.64448 7.59125 4.62998 7.60584 4.55657 8.13584C4.49769 8.5375 3 19.8642 3 19.8642L14.6722 22L21 20.6667C21 20.6525 18.7833 6 18.7684 5.9ZM14.0261 4.75209C13.6968 4.84762 13.3689 4.94805 13.0426 5.05334V4.83834C13.0426 4.2075 12.9543 3.69125 12.8079 3.27584C13.3951 3.36166 13.7765 4.00666 14.0261 4.75209ZM12.0736 3.41875C12.2349 3.82041 12.3382 4.37959 12.3382 5.15375V5.26834C11.6917 5.46916 11.0018 5.67 10.2969 5.885C10.6937 4.40834 11.4421 3.69125 12.0736 3.41875ZM11.2949 2.68834C11.4122 2.68834 11.5296 2.73125 11.6328 2.80291C10.7812 3.19 9.88553 4.165 9.50364 6.12916C8.94595 6.30125 8.40278 6.45875 7.88861 6.61666C8.32939 5.12541 9.40082 2.68834 11.2949 2.68834Z" fill="#95BF47" />
          <path d="M18.7028 5.39031C18.6332 5.39031 17.1435 5.27335 17.1435 5.27335C17.1435 5.27335 16.1134 4.19055 15.9884 4.07316C15.9483 4.02871 15.8933 4.00246 15.8351 4L15 22L21 20.639C21 20.639 18.8978 5.66846 18.884 5.56639C18.8717 5.5226 18.8483 5.48312 18.8164 5.45213C18.7845 5.42114 18.7453 5.39978 18.7028 5.39031Z" fill="#5E8E3E" />
        </g>
        <defs>
          <mask id="mask0_shopify" maskUnits="userSpaceOnUse" x="3" y="2" width="18" height="20">
            <rect x="3" y="2" width="18" height="20" fill="white" />
            <path d="M13 9.28329L12.1951 11.5181C12.1951 11.5181 11.4815 11.1646 10.6158 11.1646C9.34047 11.1646 9.27957 11.914 9.27957 12.0977C9.27957 13.1163 12.1346 13.5126 12.1346 15.9028C12.1346 17.7837 10.8589 19 9.12776 19C7.04759 19 6 17.7977 6 17.7977L6.56174 16.0865C6.56174 16.0865 7.65523 16.9633 8.56602 16.9633C9.17366 16.9633 9.41638 16.5251 9.41638 16.1995C9.41638 14.8702 7.07804 14.8135 7.07804 12.6214C7.07804 10.7828 8.49013 9.00048 11.3597 9.00048C12.4532 8.98651 13 9.28329 13 9.28329H13Z" fill="black" />
          </mask>
        </defs>
      </g>
    </svg>
  ),
);

Shopify.displayName = 'Shopify';

export default Shopify;
